/**
 * Format a number for display with international thousand separators (e.g. 1,234,567.89).
 * Use only for read-only display — do not bind this into edit inputs.
 */
export function formatPrice(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const num = parseFloat(value);
  if (Number.isNaN(num)) {
    return value;
  }
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
